"use client";

import { FC } from "react";
import { openExternalLink } from "@/utils/helpers";
import CustomIcon from "@/components/ui/custom-icon";
import { InstructionResource } from "@/api/generated-api";
import { useTranslations } from "next-intl";
import S from "./index.module.scss";

interface IVendorItem {
  vendor: InstructionResource;
}

const VendorItem: FC<IVendorItem> = ({ vendor }) => {
  const t = useTranslations();

  return (
    <div className={S.vendorWrap}>
      <span className={S.vendorName}>{vendor.product_article}</span>
      {vendor.download_url && (
        <button className={S.vendorDownloadBtn} onClick={() => openExternalLink(vendor.download_url)}>
          <span className={S.vendorDownloadBtnTitle}>{t("download")}</span>
          <CustomIcon fileName="icon-download" />
        </button>
      )}
    </div>
  );
};

export default VendorItem;
